import script from "./SocialSecurityDetailPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./SocialSecurityDetailPanel.vue?vue&type=script&setup=true&lang=ts"

import "./SocialSecurityDetailPanel.vue?vue&type=style&index=0&id=5b8978af&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b8978af"]])

export default __exports__